import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import getContext from 'recompose/getContext';
import { connect } from 'react-redux';
import { canSellGiftCards, getActiveShop, getIsRentalBarber } from '../../auth/selectors';
import withPermissions from '../../auth/utils/withPermissions';
import { hasActiveRegister } from '../cashRegister/selectors';
import Header from '../components/Header';

export default compose(
  withPermissions,
  getContext({
    toggleSidebar: PropTypes.func.isRequired,
  }),
  connect((state, ownProps) => ({
    baseUrl: state.auth.barberUser ? '/barber/register' : '/register',
    registerOpened: hasActiveRegister(state),
    openSidebar: () => ownProps.toggleSidebar(true),
    canUseGiftCards: canSellGiftCards(state),
    isRentalBarber: getIsRentalBarber(state),
    shop: getActiveShop(state),
    user: state.auth.user,
  })),
)(Header);
